// extracted by css-extract-rspack-plugin
export default {"calendar":"calendar_ZSuoy"};